import { render } from "./BasicFullCalendar.vue?vue&type=template&id=074f2dcc&scoped=true"
import script from "./BasicFullCalendar.vue?vue&type=script&lang=js"
export * from "./BasicFullCalendar.vue?vue&type=script&lang=js"

import "./BasicFullCalendar.vue?vue&type=style&index=0&id=074f2dcc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-074f2dcc"

export default script